/**
 * Newsletter signup configuration.
 *
 * Despite the "SendGrid widget" markup this is inherited from, the browser does
 * not talk to SendGrid. It posts to the Quantstamp form handler, which holds the
 * SendGrid API key and adds the address to the list configured server-side
 * (`SENDGRID.LIST_IDS` in qs-form-handler). The `token` below is passed through
 * for compatibility with the widget payload but the handler does not read it —
 * there is a single list, chosen by the server, not by this token.
 */

export const NEWSLETTER_ENDPOINT = "https://forms.quantstamp.com/submit/qs-email-form";

/** Matches the `data-token` on quantstamp.com's live signup widget. */
export const NEWSLETTER_LIST_TOKEN = "a68451348a2eb62644eb22da5e15a4f0";

/** The action name the live widget reports to reCAPTCHA; kept identical for consistent scoring. */
export const NEWSLETTER_RECAPTCHA_ACTION = "pressRequest";
